import DedupTargetIcon from "@core/Modules/JourneyBuilder/Assets/Checkpoints/icon_dedup_T.png";

import Checkpoint from "./checkpoint";
import { timeUnitLabelLookup, ListElementBuilder } from './util';
import { fromSeconds } from '@core/Util/time';
import resource from "@core/Util/resources";

export default class DeduplicationTargetCheckpoint extends Checkpoint {
    constructor() {
        super('dedupTarget', 'JourneyBuilder_Checkpoint_DeduplicationTarget', 'JourneyBuilder_Checkpoint_DeduplicationTarget_Description', { iconPath: DedupTargetIcon });
    }

    get defaultOrder() {
        return 1;
    }

    buildTooltip(connection) {
        const config = this.readForConnection(connection);

        const builder = new ListElementBuilder();

        if(config.fields) {
            config.fields.forEach(field => builder.add(field));
        }

        if(config.term && config.term.seconds) {
            builder.add(
                `${resource('JourneyBuilder_DeduplicationSettings_Term_Label')} - ${fromSeconds(config.term.seconds, config.term.unit)} ${timeUnitLabelLookup[config.term.unit]}`
            );
        }

        return {
            title: 'Deduplication checkpoint (target)',
            content: builder.toString()
        }
    }
}